import { useEffect, useState } from 'react';
import { AIPulseBanner } from './AIPulseBanner';
import { ArcusBanner } from './ArcusBanner';
import { QadarBanner } from './QadarBanner';

const ROTATION_MS = 8000;

export function RotatingPromoBanner() {
  const banners = [AIPulseBanner, ArcusBanner, QadarBanner];
  const [index, setIndex] = useState(() => Math.floor(Math.random() * banners.length));

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % banners.length);
    }, ROTATION_MS);
    return () => clearInterval(id);
  }, [banners.length]);

  const Current = banners[index];
  return <Current key={index} />;
}
